"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform["Web"] = "web";
    Platform["ReactNative"] = "reactnative";
    Platform["Node"] = "node";
    Platform["Unknown"] = "unknown";
})(Platform = exports.Platform || (exports.Platform = {}));
